<template>
	<!-- <div class="edit_wrap"> -->
		<div class="nubPer"  v-if="edhide">
			<div class="nubPer_tit">
				<i class="back" @click="goback"></i>
				<span>{{title}}期数</span>
			</div>
			<div class="periods_form">
				<div class="periods_inf clearfix">
					<div class="fl_left tit">期数名称</div>
					<div class="fl_left">
						<input type="text" placeholder="请填写名称，例：第一期" class="per_txt"  v-model="name">
					</div>
				</div>
				<div class="periods_inf clearfix" v-if="danceId!='429d5162vx84bd680412'">
					<div class="fl_left tit">级别</div>
					<div class="fl_left">
						<Select v-model="level_id" class="bordiv per_txt" placeholder="请选择级别" filterable style="width:332px;padding-left:14px;">
						    <Option v-for="item in levelArr" :key="item.id" :value="item.id" >{{ item.name}}</Option>
						</Select>
					</div>
				</div>
				<div class="periods_inf clearfix">
					<div class="fl_left tit">课节数</div>
					<div class="fl_left">
						<input type="text" placeholder="请填写该期课节数，例：20" class="lesson" v-model="total_table" @input="total_table = total_table.replace(/[^\d]/g,'')">
					</div>
				</div>
				<div class="periods_inf clearfix">
					<div class="fl_left tit">价格</div>
					<div class="fl_left">
						<input type="text" placeholder="请填写价格" class="price" v-model="price" :disabled="!is_money"> 
					</div>
					<div class="fl_left" style="line-height:40px;margin-left:20px;">
						是否收费：
						<i-Switch v-model="is_money">
					        <span slot="open">是</span>
					        <span slot="close">否</span>
					    </i-Switch>
					</div>
				</div>
				<div class="periods_inf clearfix">
					<div class="fl_left tit">优惠价格</div>
					<div class="fl_left">
						<input type="text"  name="" style="display:none"> 
						<input type="text" placeholder="请填写价格" class="price" v-model="discount_price" :disabled="!is_money"> 
					</div>
				</div>
				<div class="periods_inf clearfix">
					<div class="fl_left tit">简介</div>
					<div class="fl_left area_txt">
						<textarea name="" id="" class="introduction" placeholder="简介" @keydown="size_reduce" v-model="introduce"></textarea>
						<span class="num_size" v-model="size_num">{{size_num}}</span>
					</div>
				</div>
				<div class="vue-uploader periods_inf clearfix">
					<div class="fl_left tit">封面</div>
					<div class="fl_left">
						<div class="file-list">
				            <!-- <section class="file-item draggable-item" v-if="logo">
				                <img :src="logo" alt="" ondragstart="return false;" >
				            </section>
				            <section v-else class="file-item">
				                <div class="add"></div>
				            </section> -->
				            <div class="urlLogo urlLogo1" >
				                <img :src="logo" alt="" v-if="logo">
				                <div class="add" v-if="!logo"></div>
				                <!-- <img src="static/imgs/up_zjz.png" alt="" v-if="!logo"> -->
				                <input type="file" id="file1" multiple="false" @change="doUpload(1)"/>
				            </div>
				        </div>
					</div>
			    </div>
		    	<div class="vue-uploader periods_inf clearfix">
		    		<div class="fl_left tit">活动切图(选填)</div>
		    		<div class="fl_left">
		    			<div class="file-list">
		    				<div class="fl_left" style="width: 700px;">
		    					<div class="vue-oss-imgsrc fl_left" v-for="(value,key) in imgUrls">
		    						<img :src="value" alt="">
		    						<div class="marksd" @click="delImg(key)"></div>
		    					</div>
		    					<div class="urlLogo urlLogo1 fl_left" >
		    					    <div class="add"></div>
		    					    <!-- <img src="static/imgs/up_zjz.png" alt="" v-if="!logo"> -->
		    					    <input type="file" id="file2" @change="doUpload(2)"/>
		    					</div>
		    					<div class="clear"></div>
		    				</div>
		    	            <!-- <vue-ueditor-wrap v-model="content" :config="myConfig"></vue-ueditor-wrap> -->
		    	        </div>
		    		</div>
		        </div>
			</div>
			<!-- <div class="vue-oss-uploader-wrap" v-if="UPload">
				<div class="vue-oss-uploader">
					<div class="vue-oss-uploader-top clearfix">
						<div class="vue-oss-top-title">选择文件</div>
						<div class="vue-oss-top-button" @click="addUpload">本地上传</div>
						<input type="file" @change="fileChanged" ref="file" multiple="multiple" accept="image/jpg,image/jpeg,image/png,image/bmp">
						<div class="vue-oss-top-close" @click="qx_oss()">×</div>
					</div>
					<div class="vue-oss-uploader-content">
						<div class="vue-oss-uploader-information clearfix">
							<div class="vue-oss-imgsrc fl_left" v-for="(item,index) in imgUrl" @click="selectImg(index)">
								<img :src="item" alt="">
								<div class="mark"><i class="fa fa-check"></i></div>
							</div>
						</div>
						<div class="vue-oss-button" @click="qd_oss">确定</div>
					</div>
				</div>
			</div> -->
			<div class="btn_edit">
				<button class="btn" @click="save_request()">确定</button>
				<button class="btn btn1" @click="cancle(num)">取消</button>
			</div>
			<div class="alertBox" v-show="cropShow" style="padding-top: 8%">
			    <div style="background: #fff;width: 600px;height: 445px;margin:0 auto;
			    padding-top: 20px;">
			        <div class="cropper">
			            <vueCropper
			            ref="cropper"
			            :img="option.img"
			            :outputSize="option.size"
			            :outputType="option.outputType"
			            :info="true"
			            :full="option.full"
			            :canMove="option.canMove"
			            :canMoveBox="option.canMoveBox"
			            :original="option.original"
			            :autoCrop="option.autoCrop"
			            :autoCropWidth="option.autoCropWidth"
			            :autoCropHeight="option.autoCropHeight"
			            :fixedBox="option.fixedBox"
			            >
			            </vueCropper>
			        </div>
			        <div style="width: 300px;margin: 0 auto;">
			            <div class="fl_left tanBtn tanBtned tanBtneds" @click="delCrop">取消</div>
			            <div class="fl_right tanBtn tanBtneds" @click="upload('base64')">确认裁剪</div>
			            <div class="clear"></div>
			        </div>
			    </div>
			</div>
		</div>
	<!-- </div> -->
</template>
<script>
	// import VueUeditorWrap from 'vue-ueditor-wrap';
	var priceReg = /(^[1-9]([0-9]+)?(\.[0-9]{1,2})?$)|(^(0){1}$)|(^[0-9]\.[0-9]([0-9])?$)/;
	export default{
		data(){
			return{
				levelArr:[],
				level_id:'',
				imgUrl:[],
				imgUrls:[],
				logo:'',  //封面
				introduce:'',  // 简介
				price : "", //价格
				total_table: "",   //课节数
				name: "",  //期名称
				size_num: 120,
				edhide:true,
				UPload:false,
				status: '',
                files: [],
                imgUrl:[],
                title:'编辑',
                index:"",
                is_money:true,
                discount_price:'',
                UPload:false,
				cropShow:false,
				option: {
				    img: '',//剪切图片地址
				    size: 1,//输出图片压缩比默认为1
				    full: false,//输出截图是否缩放
				    outputType: 'png',//输出图片格式
				    canMove: true,//是否可以拖动图片
				    fixedBox: true,//是否固定截图大小
				    original: false,//上传图片按原始比例
				    canMoveBox: false,//是否可以拖动截图框
				    autoCrop: true,//是否自成截图框
				    // 只有自动截图开启 宽度高度才生效
				    autoCropWidth: 484,//截图框宽
				    autoCropHeight: 308,//截图框高
				    centerBox: false,//截图框能否超过图片
				    high: true//是否根据dpr输出高清图片
				},
				logo:'',
                file_url1:'',
	            myConfig: {
		            // 如果需要上传功能,找后端小伙伴要服务器接口地址
		            serverUrl: '',
		            // 你的UEditor资源存放的路径,相对于打包后的index.html
		            UEDITOR_HOME_URL:'./static/UEditor/',
		            // 编辑器不自动被内容撑高
		            autoHeightEnabled: true,
		            // 初始容器高度
		            initialFrameHeight: 260,
		            // 初始容器宽度
		            initialFrameWidth: 700,
		            // 关闭自动保存
		            enableAutoSave: false,
		            //启用自动保存
		            //是否保持toolbar的位置不动,默认true
		            autoFloatEnabled:false,
			        // enableAutoSave: true,
			        //自动保存间隔时间， 单位ms
			        // saveInterval: 500
			        autoSyncData:true,

			        //启用或关闭图片拉伸缩放
			        imageScaleEnabled:true,

			        //图片操作的浮层开关，默认打开
			        imagePopup:true,

			        //打开右键菜单功能
			        enableContextMenu:false,

			        indent: true,                  // 行首缩进
				    
				    indentValue : '2em',            //行首缩进的大小

			        pasteplain:true ,//是否默认为纯文本粘贴。false为不使用纯文本粘贴，true为使用纯文本粘贴
			        //菜单按钮
			        toolbars: [[
			        	'fullscreen', 'undo', 'redo', '|','bold', 'italic', 'underline', '|', 'indent','rowspacingtop', 'rowspacingbottom', 'lineheight', '|', 'paragraph', 'fontfamily', 'fontsize', '|','justifyleft', 'justifycenter', 'justifyright', 'justifyjustify', '|' 
			        ]],
			        elementPathEnabled:false,
			        wordCount:false,
		        },
		        content: '',
		        FileUrls:[],
		        imgUrlEd:[],
			}
		},
		/*components: {
		    VueUeditorWrap
		},*/
		props:['dancelist','danceId'],
		mounted(){
          	if (window.history && window.history.pushState) {
            	history.pushState(null, null, document.URL);
            	window.addEventListener('popstate', this.goback, false);
          	}
        },
		methods:{
			getLvel(index){
                let _this=this; 
                _this.$axios.post('getlevellist',{
					is_course:1,
					dance_id:_this.danceId
				}).then(res=>{
                    if(res.data.code==200){
                        if(index==1){
                            _this.levelArr=res.data.data;
                        }
                        else{
							if (_this.danceId != '429d5162vx84bd680412') {
                            	 _this.level_id=res.data.data[0].id;
							}else{
                                 _this.level_id=0;
							}
                            _this.levelArr=res.data.data;
                        }
                    }
                    else{
                        this.$Message.error(res.data.message);
                    }
                }).catch(function (error) {
                  console.log(error);
                });
            },
			delImg(index){
				let _this=this;
				this.$confirm('确定删除这张照片?', '提示', {
		          	onfirmButtonText: '确定',
		          	cancelButtonText: '取消',
		         	type: 'warning'
		     	}).then(() => {
					//  var img_url1 = JSON.parse(JSON.stringify(_this.imgUrls))
					//  var img_url2 = JSON.parse(JSON.stringify(_this.imgUrl))
					//  img_url1.splice(index,1)
					//  img_url2.splice(index,1)
					//  _this.imgUrls = img_url1
					//   _this.imgUrls = img_url1
		     		if(_this.dancelist.keys.id != null){
		     			_this.imgUrls.splice(index,1);
		     		}
		     		else{
		     			_this.imgUrls.splice(index,1);
		     			_this.imgUrl.splice(index,1);
		     		}
		     		_this.$message.success('删除成功!');
		     		// console.log(_this.imgUrl);
		        }).catch(() => {          
		        });
			},
			goback(){
				this.$emit('edits','false');
				this.edhide = false;
			},
			size_reduce(){
				var con=document.querySelector('.introduction');
				var num=document.querySelector('.num_size');
				if(con.value.length > 120){
					con.value=con.value.substring(0,120);
				}else{
					num.innerHTML = 120 - con.value.length;
				}
			},
			//提交
			save_request(){
				let _this = this;
				if(_this.name == ''){
					_this.$message.error('期数名称不可为空')
				}
				else if(_this.total_table == ''){
					_this.$message.error('课节数不可为空')
				}
				else if(_this.price == '' && _this.is_money){
					_this.$message.error('价格不可为空')
				}
				else if(!priceReg.test(_this.price) && _this.is_money){
					_this.$message.error('请输入正确的金额')
				}
				else if(_this.discount_price == '' && _this.is_money){
					_this.$message.error('价格不可为空')
				}
				else if(!priceReg.test(_this.discount_price) && _this.is_money){
					_this.$message.error('请输入正确的优惠金额')
				}
				else if(_this.introduce == ''){
					_this.$message.error('简介不可为空')
				}
				else if(_this.logo == ''){
					_this.$message.error('期数封面不可为空')
				}
				else{
					if(_this.dancelist.keys.id != null){
						let str=[],arr=[];
						for(var i=0;i<_this.FileUrls.length;i++){
						    // let show=/(http://gewu)/.test(_this.FileUrls[i])
						    // let show=_this.FileUrls[i].indexOf('blob:http:')
						    // console.log(show);
						    if(_this.FileUrls[i].indexOf('blob:http:') == -1){
						        str.push(_this.FileUrls[i]);
						    }
						}
						_this.FileUrls=str;
						// console.log(str);
						// console.log(_this.imgUrlEd);
						for(var j=0;j<_this.imgUrlEd.length;j++){
						    // let show=/(http://gewu)/.test(_this.FileUrls[i])
						    let show=_this.imgUrlEd[j].indexOf('blob:http:')
						    if(show == -1){
						        arr.push(_this.imgUrlEd[j]);
						        // _this.imgUrlEd.splice(j,1)
						    }
						}
						_this.imgUrlEd=arr;
						_this.imgUrl=_this.imgUrlEd.concat(_this.FileUrls);
						// console.log(_this.FileUrls);
						/*for(var i=0;i<_this.FileUrls.length;i++){
							// let show=/(http://gewu)/.test(_this.FileUrls[i])
							let show=_this.FileUrls[i].indexOf('blob:http:')
							if(show != -1){
								_this.FileUrls.splice(i,1)
							}
						}
						for(var i=0;i<_this.imgUrlEd.length;i++){
							// let show=/(http://gewu)/.test(_this.FileUrls[i])
							let show=_this.imgUrlEd[i].indexOf('blob:http:')
							if(show != -1){
								_this.imgUrlEd.splice(i,1)
							}
						}*/
						// console.log(_this.imgUrlEd);
						// console.log(_this.FileUrls);
						// _this.imgUrl=_this.imgUrlEd.concat(_this.FileUrls);
						/*for(var i=0;i<_this.imgUrl.length;i++){
							// let show=/(http://gewu)/.test(_this.FileUrls[i])
							let show=_this.imgUrl[i].indexOf('blob:http:')
							if(show != -1){
								_this.imgUrl.splice(i,1)
							}
						}*/
						// console.log(_this.imgUrl);
						_this.$axios.post('editissue',{
							issue_id:_this.dancelist.keys.id,
							lesson_num:_this.total_table,
							name:_this.name,
							introduce:_this.introduce,
							price: (_this.is_money ? (_this.price * 100) : 0),
							discount_price:(_this.is_money ? (_this.discount_price * 100) : 0),
							cover: _this.file_url1,
							is_free:(_this.is_money ? 0 : 1),
							imgs:_this.imgUrl,
							level_id:_this.level_id,
							dance_id:_this.danceId,
						}).then((res)=>{
							if(res.data.code == 200){
								_this.$emit('edits','false');
								_this.edhide = false;
							}
							else{
								_this.$message.error(res.data.message)
							}
						}).catch( error =>{
							console.log(error)
						})
					}
					else{
						_this.$axios.post('addissue',{
							// cate_id:_this.dancelist.keys.cate_id,
							lesson_num:_this.total_table,
							name:_this.name,
							introduce:_this.introduce,
							price: (_this.is_money ? (_this.price * 100) : 0),
							discount_price:(_this.is_money ? (_this.discount_price * 100) : 0),
							cover: _this.file_url1,
							is_free:(_this.is_money ? 0 : 1),
							imgs:_this.imgUrl,
							level_id:_this.level_id,
							dance_id:_this.danceId,
						}).then( res =>{
							if(res.data.code == 200){
								_this.$emit('edits','false')
			               		_this.edhide = false;
							}
							else{
								_this.$message.error(res.data.message)
							}
						}).catch( error =>{
							console.log(error)
						})
					}
					
				}
			},
			//取消
			cancle(num){
				let _this = this;
				if(_this.num == 1){
					_this.$confirm('此操作将不会保存您修改的内容, 是否继续?', '提示', {
			          	onfirmButtonText: '确定',
			          	cancelButtonText: '取消',
			         	type: 'warning'
			     	}).then(() => {
			          	_this.$message({
				            type: 'success',
				            message: '放弃保存修改内容'
			         	});
			         	_this.$emit('edits','false');
			         	_this.edhide = false;
			        }).catch(() => {       
			        });
		        }
		        else{
		        	_this.$emit('edits','false');
			        _this.edhide = false;
		        }
			},
			//详情
			get_package(){
				let _this = this;
				if(_this.dancelist.keys.id != null){
					_this.getLvel(1)
					_this.level_id = _this.dancelist.keys.level_id
					_this.name =  _this.dancelist.keys.name
					_this.introduce =  _this.dancelist.keys.introduce
					_this.price =  _this.dancelist.keys.price
					_this.discount_price =  _this.dancelist.keys.discount_price
					_this.total_table =  _this.dancelist.keys.lesson_num
					_this.logo =  _this.dancelist.keys.cover
					_this.file_url1 = _this.dancelist.keys.cover
					_this.size_num = this.size_num - ( _this.introduce.length);
					_this.title = "编辑"
					_this.num = 0
					_this.is_money = (_this.dancelist.keys.is_free == 1  ? false : true)
					// _this.imgUrl = _this.dancelist.keys.imgs
					_this.imgUrls = _this.dancelist.keys.imgs
					_this.FileUrls = _this.dancelist.keys.imgs
					// _this.imgUrl = _this.dancelist.keys.imgs
				}
				else{
					_this.title = "新建"
					_this.name =  ""
					_this.introduce = ""
					_this.price =  ""
					_this.discount_price = ""
					_this.total_table =  ""
					_this.logo =  ""
					_this.file_url1=""
					_this.size_num = 120
					_this.num = 1
					_this.getLvel()
				}
			},
			//点击上传图片事件
            doUpload(index){
                let _this = this;
                _this.clnum=index;
                if(index==1){
                    var files = document.getElementById('file1');
                    var fileLen = document.getElementById('file1').files;
                    var filename=$('#file1').val();
                    // _this.uploadByOss(fileLen[0])
                    // _this.option.autoCropWidth=241;//截图框宽
                    // _this.option.autoCropHeight=337;//截图框高
                    // _this.option.img=URL.createObjectURL(fileLen[0]);
                    _this.uploadByOss(fileLen[0]);
                    // _this.cropShow=true;
                    _this.logo=URL.createObjectURL(fileLen[0]);
                    $('#file1').val('')
                }
                else{
                	var files = document.getElementById('file2');
                	var fileLen = document.getElementById('file2').files;
                	var filename=$('#file2').val();
                	let num=_this.imgUrls.length;
                	// _this.imgUrls[num]=URL.createObjectURL(fileLen[0]);
                	_this.imgUrls.push(URL.createObjectURL(fileLen[0]));
                	// console.log(_this.imgUrls);
                	// _this.$nextTick(() => {
                		// var fileLen = document.getElementById('file2').files;
                		// console.log(fileLen[0]);
		                _this.uploadByOss(fileLen[0]); 
		                // console.log(_this.imgUrls);
		                
		            // })
                	// _this.uploadByOss(fileLen[0]); 
                	$('#file2').val('')
                	// _this.imgUrl=[];
                	
                }
            },
            //图片地址
            upload(type){
                let _this=this;
                _this.$refs.cropper.getCropData((dataURL) => {
                    let base64 = dataURL.split(',')[1];
                    let fileType = dataURL.split(';')[0].split(':')[1];
                    let blob = this.toBlob(base64,fileType);
                    let reader = new FileReader();
                    reader.readAsArrayBuffer(blob);
                    reader.onload = function (event) {
                        var file = new File([blob],new Date().getTime()+'.'+blob.type.split('/')[1],{type: "image/png"})
                        _this.uploadByOss(file)
                        if(_this.clnum==1){
                            _this.logo=dataURL;
                        }
                    }

                })
            },
            //裁剪弹窗隐藏
            delCrop(){
                this.cropShow=false;
            },
            //二进制转换
            toBlob(urlData,fileType){
                var bytes=window.atob(urlData),
                    n=bytes.length,
                    u8arr=new Uint8Array(n);
                while(n--){
                    u8arr[n]=bytes.charCodeAt(n);
                }
                return new Blob([u8arr],{type:fileType});
            },
            random_string(len) {
                len = len || 32;
                var chars = "ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678";
                var maxPos = chars.length;
                var pwd = "";
                for (var i = 0; i < len; i++) {
                    pwd += chars.charAt(Math.floor(Math.random() * maxPos));
                } 
                return pwd;
            },
            //阿里云上传
            uploadByOss(file){
                let _this = this;
                const loading = this.$loading({
                    lock: true,
                    text: '加载中...',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                });
                var fileurl =new Date().getTime() + _this.random_string(16)+'.'+file.name.split('.')[1];
                return new Promise(function(resolve , reject){  // Promise 一定要在函数的最外层才有效
                    _this.$axios.post('policyaction').then(function(res){
                         var re = res.data.data;
                         var osssignature = {
                            'key' : re.dir+fileurl,
                            'policy': re.policy,
                            'OSSAccessKeyId': re.accessid,
                            'success_action_status' : '200', 
                            'signature': re.signature,
                            'callback':re.callback,
                        };
                        var formData = new FormData()
                        for( var k in osssignature ){
                            formData.append(k, osssignature[k])
                        }
                        //var suffix = _this.get_suffix(file.type); // 获取文件扩展名
                        formData.append("key", re.dir);
                        formData.append('file', file)  // 必须放最后
                        var xhr = new XMLHttpRequest()
                        //xhr.upload.addEventListener('progress', uploadProgress, false)
                        xhr.open('POST', re.host, true)
                        xhr.send(formData)
                        xhr.onload = () => {
                            if (xhr.status === 200 || xhr.status === 304) {
                            	if(_this.clnum==1){
                            		_this.file_url1 = xhr.responseURL + re.dir + fileurl;
                            		_this.cropShow=false;
                            		loading.close();
                            	}
                                else{
                                	if(_this.dancelist.keys.id != null){
                                		_this.imgUrlEd.push(xhr.responseURL + re.dir + fileurl);
                                	}
                                	else{
                                		_this.imgUrl.push(xhr.responseURL + re.dir + fileurl);
                                	}
                                	loading.close();
                                }
                            } else {
                                console.log(`error：error code ${xhr.status}`)
                            }
                        }             
                    })
                })
            }, 
		},
		created(){
			let _this = this;
			_this.get_package();			
		},
		mounted(){
		}
	};
</script>
<style scoped>
.nubPer_tit{
	background: #fff;
	/*width: 922px;*/
	height: 64px;
	box-sizing: border-box;
	padding-left: 30px;
	color: #333;
	font-weight: bold;
	line-height: 64px;
	font-size: 16px;
	margin-bottom: 10px;
}
.back{
	display: inline-block;
	width: 27px;
	height: 27px;
	background: url(../../../static/imgs/back_purple.png) 0 center no-repeat;
	vertical-align: middle;
	margin-right: 12px;
}


.per_txt{
	width: 650px;
	height: 40px;
	line-height: 40px;
	font-size: 14px;
	padding-left: 24px;
	box-sizing: border-box;
	background: #fff;
	border:1px solid #ddd;
	border-radius: 4px;
}
.price,.lesson{
	width: 332px;
	height: 40px;
	line-height: 40px;
	font-size: 14px;
	padding-left: 24px;
	box-sizing: border-box;
	background: #fff;
	border:1px solid #ddd;
	border-radius: 4px;
}
.introduction{
	width: 648px;
	height: 80px;
	box-sizing: border-box;
	line-height: 16px;
	border:1px solid #ddd;
	background: #fff;
	resize: none;
	border-radius: 4px;
	padding: 13px 16px 13px 24px;
}


	.periods_form{
		background: #fff;
		padding-top: 30px;
		padding-bottom: 30px;
		/*width: 922px;*/
		box-sizing: border-box;
	}

	.periods_inf{
		width: 850px;
		margin: 0 auto 30px;
	}
/*	.periods_inf:nth-last-of-type(1){
		margin-bottom: 0;
	}*/
	.tit{
		width: 125px;
		height: 40px;
		line-height: 40px;
		box-sizing: border-box;
		padding-right: 20px;
		text-align: right;
	}
	
	.area_txt{
		position: relative;
	}
	.num_size{
		position: absolute;
		bottom: 13px;
		right: 16px;
		color: #999;
		font-size: 12px;
	}
	.btn_edit{
		/*margin-left: 106px;
		margin-top: 30px;*/
		margin: 30px auto 0;
		width: 300px;
	}
	.btn{
		width: 102px;
		height: 36px;
		line-height: 36px;
		text-align: center;
		color: #fff;
		background: #c30d23;
		border-radius: 4px;
		border:1px solid #c30d23;
		cursor: pointer;
	}
	.btn1{
		border:1px solid #bfbfbf;
		color: #333;
		background: #fff;
		margin-left: 25px;
	}
	.upload label {
      width: 200px;
      height: 136px;
      display: block;
      border-radius: 2px;
      color: #fff;
      text-align: center;
      font-size: 12px;
      background-color: #f5f5f5;
      cursor: pointer;
      }
  /*input[type='file'] {
    display: none;
    z-index: 10;
    width: 200px;
    font-size: 0;
    height: 136px;
    opacity: 0;
  }*/
	.cFile{
		width: 200px;
		height: 136px;
		position: relative;
	}
	.add_img{
		position: absolute;
		top: 50%;
		left: 50%;
		transform: translateX(-50%) translateY(-50%);
		text-align: center;
		font-size: 12px;
	}
	p{
		margin: 0;
		padding: 0;
	}
	.add_img p{
		color: #fff;
		background: #8b92cf;
		width: 28px;
		height: 28px;
		line-height: 28px;
		text-align: center;
		border-radius: 50%;
		transform: translateX(50%);
		margin-bottom: 9px;
	}
	.img-container{
		width: 200px;
		height: 136px;
		margin-right: 20px;
	}
	.img-container .imgs_con{
		width: 100%;
		height: 100%;
		background-repeat: no-repeat;
		background-position: center center;
	}

	.file-list{
		cursor: pointer;
	}
	.vue-uploader .file-list:after {
    content: '';
    display: block;
    clear: both;
    visibility: hidden;
    line-height: 0;
    height: 0;
    font-size: 0;
}
.vue-uploader .file-list .file-item {
    float: left;
    margin-left: 10px;
    position: relative;
    width: 200px;
    height: 136px;
}
.vue-uploader .file-list .draggable-item{
	width: 200px;
    height: 136px;
    display: flex;
    justify-content: center;
    align-items: center;
}
.vue-uploader .file-list .file-item img{
    max-width: 200px;
    max-height: 136px;
}
.vue-uploader .file-list .file-item .file-remove {
    position: absolute;
    right: 4px;
    display: none;
    top: 4px;
    width: 20px;
    height: 20px;
    font-size:20px;
    text-align: center;
    color: white;
    cursor: pointer;
    line-height: 20px;
    border-radius: 100%;
    transform: rotate(45deg);
    background: rgba(0, 0, 0, 0.5);
}
.vue-uploader .file-list .file-item:hover .file-remove {
    display: inline;
}
.vue-uploader .file-list .file-item .file-name {
    margin: 0;
    height: 40px;
    word-break: break-all;
    font-size: 14px;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
}
.vue-uploader .add {
    width: 200px;
    height: 136px;
    float: left;
    cursor: pointer;
    background: url(../../../static/imgs/upload.jpg) no-repeat;  /*// 这里使用的是我本地图片*/
    background-size: 100% 100%;
}
.vue-uploader .upload-func {
    display: flex;
    padding: 10px;
    margin: 0px;
    background: #f8f8f8;
    border-top: 1px solid #ececec;
}
.vue-uploader .upload-func .progress-bar {
    flex-grow: 1;
}
.vue-uploader .upload-func .progress-bar section {
    margin-top: 5px;
    background: #00b4aa;
    border-radius: 3px;
    text-align: center; 
    color: #fff;
    font-size: 12px;
    transition: all .5s ease;
}
.vue-uploader .upload-func .operation-box {
    flex-grow: 0;
    padding-left: 10px;
}
.vue-uploader .upload-func .operation-box button {
    padding: 4px 12px;
    color: #fff;
    background: #007ACC;
    border: none;
    border-radius: 2px;
    cursor: pointer;
}
.vue-uploader > input[type="file"] {
    display: none;
}



.vue-oss-uploader-wrap{
		position: fixed;
		top: 50%;
		left: 50%;
		transform: translateX(-50%) translateY(-50%);
		width:100%;
		height: 100%;
		background: rgba(0,0,0,0.5);
	}
	.vue-oss-uploader{
		width: 846px;
		height: 538px;
		position: absolute;
		top: 50%;
		left: 50%;
		transform: translateX(-50%) translateY(-50%);
		background: #fff;
		border-radius: 10px;
	}
	.vue-oss-uploader-top{
		width:846px;
		height:50px;
		background:rgba(238,238,238,1);
		border-radius:10px 10px 0px 0px;
		position: relative;
	}
	.vue-oss-top-title{
		height:50px;
		font-size:14px;
		line-height: 50px;
		margin-left: 23px;
		font-weight:400;
		color:rgba(0,0,0,1);
		float: left;
	}
	.vue-oss-top-button{
		float: right;
		width:90px;
		height:30px;
		background:rgba(89,93,181,1);
		border-radius:4px;
		color: #fff;
		font-size: 14px;
		line-height: 30px;
		text-align: center;
		margin-top: 11px;
		margin-right: 67px;
		cursor: pointer;
	}
	.vue-oss-top-close{
		width: 22px;
		height: 22px;
		color: #999;
		position: absolute;
		top: 50%;
		margin-top: -11px;
		right: 20px;
		border-radius: 50%;
		border:1px solid #999;
		font-size: 20px;
		line-height: 18px;
		text-align: center;
		box-sizing: border-box;
		cursor: pointer;
	}
	/*.vue-oss-uploader-content{
		width: 100%;
		height: 44px;
		box-sizing: border-box;
		padding: 19px 24px;
	}*/
	.vue-oss-uploader-information{
		overflow-y: auto;
		height: 438px;
	}
	.upload-button{
		width: 58px;
		padding-bottom: 5px;
		color: #999;
		text-align: center;
	}
	.vue-oss-imgsrc{
		margin:0 20px 20px 0;
		width: 200px;
		height: 136px;
		display: flex;
		justify-content: center;
		align-items: center;
		position: relative;
		cursor: pointer;
		/*overflow: hidden;*/
	}
	.vue-oss-imgsrc img{
		display: inline-block;
		width:100%;
		height: 100%;
	}
	.marksd{
		position: absolute;
		top: -13px;
		right: -13px;
		width: 26px;
		height: 26px;
		background:url(../../../static/imgs/delete.png) center center/26px no-repeat;
	}
	.vue-oss-button{
		text-align: center;
		line-height: 30px;
		cursor: pointer;
		width: 96px;
		height: 30px;
		margin: 0 auto;
		background: #3f4399;
		color: #fff;
		border-radius: 4px;
		margin-bottom: 10px;

	}
	.vue-oss-button span{
		
		display: inline-block;
		
		line-height: 30px;
		text-align: center;
	}
</style>


// WEBPACK FOOTER //
// src/components/index/editDances.vue